import classNames from 'classnames';
import Link from 'next/link';
import s from '#components/common/logo/logo.module.scss';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  extraClass?: string;
  isSizeXl?: boolean;
  colorVariant2?: boolean;
  size?: 'small' | 'large';
  onClick?: (event) => void;
};

const Logo = ({
  extraClass,
  isSizeXl,
  colorVariant2,
  size,
  onClick,
}: Props) => {
  const { t } = useTranslation();
  const blockClass = classNames(s.host, extraClass, {
    [s.isSizeXl]: !!isSizeXl,
    [s.sizeLarge]: size === 'large',
    [s.sizeSmall]: size === 'small',
  });

  if (onClick) {
    return (
      <button
        className={blockClass}
        aria-label={t('logoLabel')}
        data-host="logo"
        onClick={onClick}
      >
        {!colorVariant2 && (
          <img src="/static/images/bg-svg-icons/purple-logo.svg" alt="logo" />
        )}
        {colorVariant2 && (
          <img src="/static/images/bg-svg-icons/pink-logo.svg" alt="logo" />
        )}
      </button>
    );
  }

  return (
    <Link href="/" legacyBehavior>
      <a className={blockClass} aria-label={t('logoLabel')} data-host="logo">
        {!colorVariant2 && (
          <img src="/static/images/bg-svg-icons/purple-logo.svg" alt="logo" />
        )}
        {colorVariant2 && (
          <img src="/static/images/bg-svg-icons/pink-logo.svg" alt="logo" />
        )}
      </a>
    </Link>
  );
};

export default Logo;
